<template>
  <section
    class="content checkout-content pt-0"
    style="background-color: white;"
  >
    <!-- <div class="container">
      <div class="row">
        <vendor-signup-banner>
        </vendor-signup-banner>
        <div class="col-12 col-md-6  order-1 order-md-2 p-3  mb-4 card">
          <div class="form-signin">
            <h1 class="h3 mb-3 font-weight-normal"
                id="sign-in-form-head"
            >
              Login to your account
            </h1>
            <vendor-login-form>

    </vendor-login-form>-->
    <!--<existing-customervendor-login-form>-->

    <!--</existing-customervendor-login-form>-->
    <!-- </div>
        </div>
      </div>
    </div>-->
    <section class="vendor-carousel">
      <div class="container">
        <div
          id="carouselExampleIndicators"
          class="carousel slide"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            <li
              data-target="#carouselExampleIndicators"
              data-slide-to="0"
              class="active"
            ></li>
            <li
              data-target="#carouselExampleIndicators"
              data-slide-to="1"
            ></li>
          </ol>
									<!--class="d-block w-100"-->
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
															src="@/assets/img/seller-desktop.jpg"
															class="image-desktop w-100"
                alt
																data-test="vendorPageTemplateImg1"
																id="vendorPageTemplateImg1"
              >
													<img
														src="@/assets/img/seller-mobile.jpg"
														class="image-mobile w-100"
														alt
														data-test="vendorPageTemplateImg1"
													>
            </div>
											<div class="carousel-item">
												<img
													src="@/assets/img/seller-desktop.jpg"
													class="image-desktop w-100"
													alt
													data-test="vendorPageTemplateImg2"
												>
              <img
															src="@/assets/img/seller-mobile.jpg"
															class="image-mobile w-100"
                alt
																data-test="vendorPageTemplateImg2"
																id="vendorPageTemplateImg2"
              >
            </div>
          </div>
          <slot />
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row py-5">
          <div class="col">
            <div class="figures">
              <img
                class="thumb"
                src="/img/icons/svg/004-24-hours.svg"
                alt
																data-test="vendorPageTemplateImg3"
																id="vendorPageTemplateImg3"
              >
              <span data-test="vendorPageTemplateSpan1"
																				id="vendorPageTemplateSpan1">
                Sell 24x7
              </span>
            </div>
          </div>
          <div class="col">
            <div class="figures">
              <img
                class="thumb"
                src="/img/icons/svg/003-customer.svg"
                alt
																data-test="vendorPageTemplateImg4"
																id="vendorPageTemplateImg4"
              >
              <span data-test="vendorPageTemplateSpan2"
																				id="vendorPageTemplateSpan2">
                Millions of users
              </span>
            </div>
          </div>
          <div class="col">
            <div class="figures">
              <img
                class="thumb"
                src="/img/icons/svg/005-payment-method.svg"
                alt
																data-test="vendorPageTemplateImg5"
																id="vendorPageTemplateImg5"
              >
              <span data-test="vendorPageTemplateSpan3"
																				id="vendorPageTemplateSpan3">
                Quick Payment
              </span>
            </div>
          </div>
        </div>
        <hr>
      </div>
    </section>
    <section>
      <div class="container">
        <h4 class="inforgraphics-title"
												data-test="vendorPageTemplateHead1"
												id="vendorPageTemplateHead1">
          How it is simple to sell on NEO BANK
        </h4>
        <div class="inforgraphics-wrapper">
          <div class="row position-relative">
            <div class="vertical-line"></div>
            <div class="col-md-5">
              <div class="infographics-main-img-warpper">
                <img
                  class="center infographics-main-img"
                  src="https://sellers.snapdeal.com/resource/1555937397000/NewUIIMG/Images1/Register_yourself_and_List_your_products.png"
																		data-test="vendorPageTemplateImg6"
																		id="vendorPageTemplateImg6"
																>
              </div>
            </div>
            <div class="col-md-2">
              <div class="infographics-img-wrapper">
                <img
                  class="inforgraphics-img ml-3"
                  src="/img/icons/svg/001-clipboard.svg"
																		data-test="vendorPageTemplateImg7"
																		id="vendorPageTemplateImg7"
                >
              </div>
            </div>
            <div class="col-md-5">
              <span class="heading"
																				data-test="vendorPageTemplateSpan4"
																				id="vendorPageTemplateSpan4">
                Step 1: Register yourself and List your products
              </span>
              <ul class="cus-pd">
                <li class="mb-10">
                  <span data-test="vendorPageTemplateSpan5"
																								id="vendorPageTemplateSpan5">
                    Register your business for free and create a product catalogue
                  </span>
                </li>
                <li class="mb-10">
                  <span data-test="vendorPageTemplateSpan6"
																								id="vendorPageTemplateSpan6">
                    Sell under your own private label or sell an existing brand
                  </span>
                </li>
                <li>
                  <span data-test="vendorPageTemplateSpan7"
																								id="vendorPageTemplateSpan7">
                    Get self-serve training
                  </span>
                </li>
                <li>
                  <span data-test="vendorPageTemplateSpan8"
																								id="vendorPageTemplateSpan8">
                    Order Packaging material from our website to start selling
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="row position-relative">
            <div class="vertical-line"></div>

            <div class="col-md-5 order-2 order-md-1">
              <span class="heading"
																				data-test="vendorPageTemplateSpan9"
																				id="vendorPageTemplateSpan9">
                Step 2: Get support from professional service provider
              </span>
              <ul class="cus-pd">
                <li class="mb-10">
                  <span data-test="vendorPageTemplateSpan10"
																								id="vendorPageTemplateSpan10">
                    Get your documentation &amp; cataloging done with ease from our Professional Services network across India
                  </span>
                </li>
                <li>
                  <span data-test="vendorPageTemplateSpan11"
																								id="vendorPageTemplateSpan11">
                    Increase your product visibility with high-quality product photo-shoot by our Partnered Photographers
                  </span>
                </li>
              </ul>
              <br>
              <br>
            </div>
            <div class="col-md-2 order-1 order-md-2">
              <div class="infographics-img-wrapper">
                <img
                  class="inforgraphics-img ml-1"
                  src="/img/icons/svg/conversation.svg"
																		data-test="vendorPageTemplateImg8"
																		id="vendorPageTemplateImg8"
                >
              </div>
            </div>
            <div class="col-md-5 order-md-3">
              <div class="infographics-main-img-warpper">
                <img
                  class="center"
                  src="https://sellers.snapdeal.com/resource/1555937397000/NewUIIMG/Images1/Get_support_from_professional_service_provider.png"
																		data-test="vendorPageTemplateImg9"
																		id="vendorPageTemplateImg9"
																>
              </div>
            </div>
          </div>
          <div class="row position-relative">
            <div class="vertical-line"></div>
            <div class="col-md-5">
              <div class="infographics-main-img-warpper">
                <img
                  class="center"
                  src="https://sellers.snapdeal.com/resource/1555937397000/NewUIIMG/Images1/Receive_orders_Schedule_a_pickup.png"
																		data-test="vendorPageTemplateImg10"
																		id="vendorPageTemplateImg10"
																>
              </div>
            </div>
            <div class="col-md-2">
              <div class="infographics-img-wrapper">
                <img
                  class="inforgraphics-img ml-3"
                  src="/img/icons/svg/008-box.svg"
																		data-test="vendorPageTemplateImg11"
																		id="vendorPageTemplateImg11"
                >
              </div>
            </div>
            <div class="col-md-5">
              <span class="heading"
																				data-test="vendorPageTemplateSpan12"
																				id="vendorPageTemplateSpan12">
                Step 3: Receive orders &amp; Schedule a pickup
              </span>
              <ul class="cus-pd">
                <li class="mb-10">
                  <span data-test="vendorPageTemplateSpan13"
																								id="vendorPageTemplateSpan13">
                    Once listed, your products will be available to millions of users across India
                  </span>
                </li>
                <li>
                  <span data-test="vendorPageTemplateSpan14"
																								id="vendorPageTemplateSpan14">
                    Get orders and manage your online business via our Store Panel and Store Zone Mobile App
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="row position-relative">
            <!-- <div class="vertical-line"></div> -->
            <div class="col-md-5 order-2 order-md-1">
              <span class="heading"
																				data-test="vendorPageTemplateSpan15"
																				id="vendorPageTemplateSpan15">
                Step 4: Receive quick payment &amp; grow your business
              </span>
              <ul class="ptl">
                <li class="mb-10">
                  <span data-test="vendorPageTemplateSpan16"
																								id="vendorPageTemplateSpan16">
                    Receive quick and hassle-free payments in your account once your orders are fulfilled
                  </span>
                </li>
                <li>
                  <span data-test="vendorPageTemplateSpan17"
																								id="vendorPageTemplateSpan17">
                    Expand your business with low interest &amp; collateral-free loans
                  </span>
                </li>
              </ul>
            </div>

            <div class="col-md-2 order-1 order-md-2">
              <div class="infographics-img-wrapper">
                <img
                  class="inforgraphics-img ml-0"
                  src="/img/icons/svg/002-file.svg"
																		data-test="vendorPageTemplateImg12"
																		id="vendorPageTemplateImg12"
                >
              </div>
            </div>
            <div class="col-md-5 order-md-3">
              <div class="infographics-main-img-warpper">
                <img
                  class="center"
                  src="https://sellers.snapdeal.com/resource/1555937397000/NewUIIMG/Images1/Receive_quick_payment_grow_your_business.png"
																		data-test="vendorPageTemplateImg13"
																		id="vendorPageTemplateImg13"
																>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="text-center mt-5">
          <h3 data-test="vendorPageTemplateHead2"
														id="vendorPageTemplateHead2">
            Start your bussiness
            <br>
            with NEO BANK &amp; reach
            <br>
            customer across India
          </h3>
          <button
            @click.prevent="scrollToTop"
            class="btn btn-md blue-btn px-4 py-2"
            style="border-radius: 3px"
												data-test="vendorPageTemplateBtn"
												id="vendorPageTemplateBtn"
          >
            Start Selling Now
          </button>
        </div>
        <br>
      </div>
    </section>
  </section>
</template>

<script>
export default {
	name: 'VendorPageTemplate',
	methods: {
		scrollToTop () {
			window.scrollTo(0, 0)
		}
	}
}
</script>
